import React from 'react';

import * as RunWorkspace from './RunWorkspace';
import {RunPagePanels} from './RunPagePanels';
import * as RunUtil from '../../util/runs';

import * as ViewHooks from '../../state/views/hooks';
import makeComp from '../../util/profiler';

interface RunPageJupyterProps {
  entityName: string;
  projectName: string;
  run: RunUtil.Run;
  readOnly: boolean;
}

export const RunPageJupyter = makeComp(
  (props: RunPageJupyterProps) => {
    const {entityName, projectName, run, readOnly} = props;

    const runPageRefNew = ViewHooks.useNewObjectRef(
      'run-view',
      RunWorkspace.EMPTY_VIEW_STATE
    );

    if (!runPageRefNew.ready) {
      return <div />;
    }
    const runPageRef = runPageRefNew.ref;

    return (
      <RunPagePanels
        entityName={entityName}
        projectName={projectName}
        run={run}
        readOnly={readOnly}
        runPageRef={runPageRef}
      />
    );
  },
  {id: 'RunPageJupyter'}
);
